<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content" v-loading="loadingStaus" :element-loading-text="loadingText">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-question"></i>
              <span v-if="$route.params.id">编辑问答</span>
              <span v-else>创建问答</span>
            </h1>
            <p class="page-subtitle">
              问答内容编辑与管理
            </p>
          </div>
        </div>

        <I18nLangBar
          v-model="contentLang"
          entity-type="fqa"
          :entity-id="formData.id || ''"
          :source-lang="sourceLang"
          :locales="contentLocales"
          @change="onContentLangChange"
          @translated="onTranslated" />

        <el-row :gutter="24">
          <el-form ref="qaForm" :model="formData" :rules="rules" label-width="120px" class="qa-form">
            <!-- 左侧主要内容区域 -->
            <el-col :span="18" class="content-left">
              <div class="form-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-document"></i>
                    基本信息
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="问题标题" prop="question" class="form-item">
                    <div class="input-wrapper">
                      <el-input 
                        v-model="formData.question" 
                        placeholder="请输入问题标题"
                        size="large"
                        class="question-input">
                      </el-input>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="form-card">
              
                <div class="card-content">
                  <el-form-item label="答案内容" prop="answer" class="form-item content-item">
                    <div class="editor-wrapper">
                      <ApeEditor
                        :key="'answer-' + contentLang + '-' + (formData.id || 'new')"
                        :init-html="formData.answer"
                        :editorHeight="380"
                        @handleTinymceInput="handleTinymceInput">
                      </ApeEditor>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            
            <!-- 右侧配置区域 -->
            <el-col class="content-right" :span="6">
              <div class="sidebar-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-setting"></i>
                    问答设置
                  </h3>
                </div>
                <div class="card-content">
                  <el-form-item label="封面图片" prop="coverimage" class="form-item">
                    <div class="upload-wrapper">
                    <el-upload
                        class="cover-uploader"
                      action="/service/upload/image"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :limit="3"
                        :headers="uploadHeaders">
                        <div v-if="coverimage" class="cover-preview">
                          <img :src="coverimage" class="cover-image" />
                          <div class="cover-overlay">
                            <i class="el-icon-camera"></i>
                            <span>更换封面</span>
                          </div>
                        </div>
                        <div v-else class="upload-placeholder">
                        <i class="el-icon-plus"></i>
                          <div class="upload-text">上传封面</div>
                          <div class="upload-hint">支持JPG/PNG格式</div>
                      </div>
                    </el-upload>
                    </div>
                  </el-form-item>
                  <el-form-item label="分类" prop="category_id" class="form-item">
                    <div class="input-wrapper">
                      <el-select 
                        v-model="formData.category_id" 
                        placeholder="选择问答分类"
                        class="category-select"
                        :disabled="!!$route.query.pid">
                        <el-option
                          v-for="item in category_list"
                          :key="item.id"
                          :label="item.category_name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  
                  <el-form-item label="状态" prop="status" class="form-item">
                    <div class="input-wrapper">
                      <el-select 
                        v-model="formData.fqa_status" 
                        placeholder="选择状态"
                        class="status-select">
                        <el-option label="发布" value="1"></el-option>
                        <el-option label="草稿" value="0"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  
                  <el-form-item label="热门问答" prop="fqa_recommend" class="form-item">
                    <div class="switch-wrapper">
                      <el-switch
                        v-model="formData.fqa_recommend"
                        :active-value="'1'"
                        :inactive-value="'0'"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="是"
                        inactive-text="否"
                        class="hot-switch">
                      </el-switch>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <div class="action-card">
                <div class="card-header">
                  <h3 class="card-title">
                    <i class="el-icon-s-tools"></i>
                    操作
                  </h3>
                </div>
                <div class="card-content">
                  <div class="action-buttons">
                    <el-button
                      size="large"
                      type="primary"
                      class="save-btn"
                      :disabled="loadingStaus"
                      @click="saveConfirm">
                      <i class="el-icon-check" v-if="!loadingStaus"></i>
                      <i class="el-icon-loading" v-else></i>
                      <span v-if="!loadingStaus">保存发布</span>
                      <span v-else>保存中...</span>
                    </el-button>
                    
                    <el-button
                      size="large"
                      class="cancel-btn"
                      @click="returnList">
                      <i class="el-icon-back"></i>
                      返回列表
                    </el-button>
                  </div>
                  
                  <div class="tips-section">
                    <div class="tip-item">
                      <i class="el-icon-info"></i>
                      <span>问题标题建议控制在50字以内</span>
                    </div>
                    <div class="tip-item">
                      <i class="el-icon-info"></i>
                      <span>答案内容要详细具体，帮助用户</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeUploader from "@/components/ApeUploader";
import ApeEditor from "@/components/ApeEditor";
import I18nLangBar from "@/components/I18nLangBar";
import i18nContentMixin from "@/mixins/i18nContentMixin";
import { mapGetters } from "vuex";


export default {
  components: {
    PageHeaderLayout,
    ApeUploader,
    ApeEditor,
    I18nLangBar,
  },
  mixins: [i18nContentMixin],
  data() {
    return {
      i18nEntityType: 'fqa',
      i18nFieldKeys: ['question', 'answer'],
      coverimage:'',
      filename: "",
      fileurl: "",
      uploadHeaders: {
        Authorization: localStorage.getItem("Authorization"),
        "x-api-key": process.env.VUE_APP_API_KEY || (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_KEY) || '',
      },
      pids:[],
      category_list:[],
      activeTab: "0",
      hearTitle: "基本设置",
      activeName: 'cn',
      loadingStaus: true,
      loadingText: "玩命提交中……",
      articleId: 0, // 新闻id，0表示创建，非零为编辑
      // element的cascader的props值
      // 新闻基本信息表单结构
      formData: {
      },
      rules: {
        question: { required: true, message: "输入问题", trigger: "blur" },
        answer: { required: true, message: "输入回答", trigger: "blur" },
        category_id: { required: true, message: "选择分类", trigger: "change" },
      },
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    async onTranslated() {
      await this.applyContentLangToForm()
    },
    handleAvatarSuccess(res) {
      if (this.$apiSuccess(res)){
        if (res.data.startsWith("http")){
          this.coverimage = res.data;
        }else if (res.data.startsWith("/")){
          this.coverimage = window.location.origin + res.data;
        }else{
          this.coverimage = window.location.origin  + "/" + res.data;
        }
        this.formData.cover_url = this.coverimage
      }else{
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt50M) {
        this.$message.error("上传头像图片大小不能超过 50MB!");
      }
      return isJPG && isLt50M;
    },
    // 返回列表
    returnList() {
      if (this.$route.query.pid) {
        this.$router.push("/cms/question?pid="+this.$route.query.pid);
      }else{
        this.$router.push("/cms/question");
      }
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs["qaForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    // 新闻相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true;
      try {
        if (this.formData.id && !this.isEditingSourceLang()) {
          await this.saveLocalizedFields()
          this.$message.success('译文已保存')
          this.loadingStaus = false
          return
        }
        let url = '/service/ola_app_fqa/create'
        if (this.formData.id == undefined || this.formData.id == ""){
            if (!this.formData.pid) {
              this.formData.pid = '0'
            }
            if (!this.formData.fqa_status) {
              this.formData.fqa_status = '1'
            }
            if (!this.formData.fqa_recommend) {
              this.formData.fqa_recommend = '0'
            }
        }else{
           url = '/service/ola_app_fqa/update'
        }
        // when creating, always save source text to main table
        let res = await this.$api.post(url,this.formData)
        if (this.$apiSuccess(res)) {
          if (res.data && res.data.detail) {
            this.captureSourceSnapshot(res.data.detail, this.i18nFieldKeys)
          } else if (res.data && res.data.result_detail) {
            this.captureSourceSnapshot(res.data.result_detail, this.i18nFieldKeys)
          } else {
            this.captureSourceSnapshot({ ...this.formData }, this.i18nFieldKeys)
          }
          this.$message.success('保存成功!')
          this.returnList()
        }else{
          this.$message.error(res.message)
        }
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '保存失败')
      }
      this.loadingStaus = false; 
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id;
      this.uploadFileList = fileList;
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message));
      }
      callback();
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.answer = val;
    },
    async getCategoryList(){
      let res = await this.$api.post('/service/ola_app_fqa_category/list',{
        current_page:1,
        page_size:1000,
        order_by:'category_rank asc'
      })
      if (this.$apiSuccess(res)){
        this.category_list = res.data.list || []
        this.initArticleForm()
      }
    },
    async initArticleForm() {
      // 子问题：继承父问题的分类，pid 指向父问题
      if (this.$route.query.pid && !this.$route.params.id) {
        let res = await this.$api.post('/service/ola_app_fqa/detail',{id:this.$route.query.pid});
        if (this.$apiSuccess(res)){
          this.formData.pid = this.$route.query.pid
          this.formData.category_id = res.data.detail.category_id
        }else{
          this.$message.error(res.message)
        }
      }
      if (this.$route.params.id) {
        let res = await this.$api.post('/service/ola_app_fqa/detail',{id:this.$route.params.id});
        if (this.$apiSuccess(res)) {
          this.captureSourceSnapshot(res.data.detail, this.i18nFieldKeys)
          this.contentLang = this.sourceLang
          this.coverimage = res.data.detail.cover_url
          await this.applyContentLangToForm()
        }else{
          this.$message.error(res.message)
        }
      }
    },
  },
  async mounted() {
    await this.loadI18nMeta()
    this.contentLang = this.sourceLang
    this.loadingStaus = true;
    this.getCategoryList()
    this.$nextTick(() => {
      this.loadingStaus = false;
    });
  },
};
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 表单样式
.qa-form
  .content-left
    .form-card
      background #fff
      border-radius 12px
      padding 24px
      margin-bottom 24px
      box-shadow 0 2px 12px rgba(0,0,0,0.1)
      border 1px solid #f0f0f0
      
      .card-header
        margin-bottom 20px
        padding-bottom 12px
        border-bottom 1px solid #f0f0f0
        
        .card-title
          font-size 18px
          font-weight 600
          color #303133
          margin 0
          display flex
          align-items center
          gap 8px
          
          i
            color #409EFF
            
      .card-content
        .form-item
          margin-bottom 24px
          
          &.content-item
            margin-bottom 0
            
          /deep/ .el-form-item__label
            font-weight 500
            color #606266
            
          .input-wrapper
            .question-input
              /deep/ .el-input__inner
                font-size 16px
                height 48px
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
            .tags-input
              /deep/ .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
          .editor-wrapper
            border 2px solid #f0f0f0
            border-radius 8px
            overflow hidden
            transition all 0.3s ease
            
            &:hover
              border-color #d4e6ff

// 右侧边栏样式
.content-right
  .sidebar-card, .action-card
    background #fff
    border-radius 12px
    padding 20px
    margin-bottom 20px
    box-shadow 0 2px 12px rgba(0,0,0,0.1)
    border 1px solid #f0f0f0
    
    .card-header
      margin-bottom 16px
      padding-bottom 10px
      border-bottom 1px solid #f0f0f0
      
      .card-title
        font-size 16px
        font-weight 600
        color #303133
        margin 0
        display flex
        align-items center
        gap 8px
        
        i
          color #409EFF
          
    .card-content
      .form-item
        margin-bottom 20px
        
        &:last-child
          margin-bottom 0
          
        /deep/ .el-form-item__label
          font-weight 500
          color #606266
          font-size 14px
          
        .input-wrapper
          .category-select, .status-select
            width 100%
            
            /deep/ .el-input__inner
              border-radius 8px
              border 2px solid #f0f0f0
              transition all 0.3s ease
              
              &:focus
                border-color #409EFF
                box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                
          .sort-input
            width 100%
            
            /deep/ .el-input__inner
              border-radius 8px
              border 2px solid #f0f0f0
              transition all 0.3s ease
              
              &:focus
                border-color #409EFF
                box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                
        .switch-wrapper
          .hot-switch
            /deep/ .el-switch__core
              border-radius 12px
              background-color #dcdfe6
              
              &::after
                border-radius 10px
                
            /deep/ .el-switch.is-checked .el-switch__core
              background-color #ff6b35
              
            /deep/ .el-switch__label
              font-size 14px
              color #606266
              
              &.is-active
                color #ff6b35

// 操作按钮样式
.action-buttons
  margin-bottom 20px
  
  .save-btn
    width 100%
    height 44px
    background linear-gradient(135deg, #67C23A 0%, #85CE61 100%)
    border none
    border-radius 8px
    font-size 16px
    font-weight 600
    color #fff
    margin-bottom 12px
    transition all 0.3s ease
    box-shadow 0 4px 12px rgba(103,194,58,0.3)
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 6px 16px rgba(103,194,58,0.4)
      
    &:disabled
      background #e4e7ed
      color #c0c4cc
      box-shadow none
      transform none
      cursor not-allowed
      
  .cancel-btn
    width 100%
    height 40px
    border 2px solid #f0f0f0
    border-radius 8px
    color #606266
    background #fff
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      border-color #409EFF
      color #409EFF

// 提示信息样式
.tips-section
  padding-top 16px
  border-top 1px solid #f0f0f0
  
  .tip-item
    display flex
    align-items center
    gap 8px
    margin-bottom 8px
    font-size 13px
    color #909399
    
    &:last-child
      margin-bottom 0
      
    i
      font-size 14px
      color #E6A23C

// 左侧内容区样式优化
.content-left
  padding-right 12px
  
  .form-card
    &:last-child
      margin-bottom 0

// 右侧边栏优化
.content-right
  padding-left 12px
  
  .sidebar-card
    position sticky
    top 20px
    
  .action-card
    position sticky
    top 300px

// 响应式设计
@media (max-width: 1200px)
  .content-left
    padding-right 8px
    
  .content-right
    padding-left 8px

@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .qa-form
    .content-left, .content-right
      padding 0
      
    .form-card, .sidebar-card, .action-card
      padding 16px
      
    .sidebar-card, .action-card
      position static
      top auto

@media (max-width: 480px)
  .page-title-section
    .title-content
      .page-title
        font-size 20px
        
  .action-buttons
    .save-btn
      height 40px
      font-size 14px
      
    .cancel-btn
      height 36px
      font-size 14px
</style>
